
import { ActivityInfo, TotalActivity } from '@luxtag/papybase';
import { filter, find, findIndex } from 'lodash';

export const MUTATE_ACTIVITIES = 'MUTATE_ACTIVITIES';
export const MUTATE_TOTAL_ACTIVITIES_DAILY = 'MUTATE_TOTAL_ACTIVITIES_DAILY';
export const MUTATE_TOTAL_ACTIVITIES_MONTHLY = 'MUTATE_TOTAL_ACTIVITIES_MONTHLY';
export const MUTATE_TOTAL_ACTIVITIES_YEARLY = 'MUTATE_TOTAL_ACTIVITIES_YEARLY';

interface IActivityStore {
    activities: ActivityInfo[];
    totalActivitiesDaily: TotalActivity[];
    totalActivitiesMonthly: TotalActivity[];
    totalActivitiesYearly: TotalActivity[];
}

// initial state
const activityState: IActivityStore = {
    activities: [],
    totalActivitiesDaily: [],
    totalActivitiesMonthly: [],
    totalActivitiesYearly: [],
};

// getters
const getters = {
    getActivities: (state: IActivityStore) => state.activities,
    getTotalActivitiesDaily: (state: IActivityStore) => state.totalActivitiesDaily,
    getTotalActivitiesMonthly: (state: IActivityStore) => state.totalActivitiesMonthly,
    getTotalActivitiesYearly: (state: IActivityStore) => state.totalActivitiesYearly,
    // eslint-disable-next-line
    getProductActivities:(state: IActivityStore) => (address: string) => filter(state.activities, activity => activity.address === address),
    // eslint-disable-next-line
    isUnclaimed: (state: IActivityStore) => (address: string) => (findIndex(state.activities, activity => activity.address === address)) === -1,
    // eslint-disable-next-line
    isClaimed: (state: IActivityStore) => (address: string) => {
        return find(state.activities, activity => activity.address === address && activity.action === 'CLAIM');
    },
    isTransferred: (state: IActivityStore) => (address: string) => find(state.activities, activity => activity.address === address && activity.action === 'TRANSFER'),
};

// mutations
const mutations = {
    [MUTATE_ACTIVITIES](state: IActivityStore, payload: ActivityInfo[]) {
        state.activities = payload;
    },
    [MUTATE_TOTAL_ACTIVITIES_DAILY](state: IActivityStore, payload: TotalActivity[]) {
        state.totalActivitiesDaily = payload;
    },
    [MUTATE_TOTAL_ACTIVITIES_MONTHLY](state: IActivityStore, payload: TotalActivity[]) {
        state.totalActivitiesMonthly = payload;
    },
    [MUTATE_TOTAL_ACTIVITIES_YEARLY](state: IActivityStore, payload: TotalActivity[]) {
        state.totalActivitiesYearly = payload;
    },
};

// actions
const actions = {
};

export default {
    state: activityState,
    getters,
    actions,
    mutations,
};
